(ns ^:dev/always bp-clients.tv-app.api.events
  "Namespaced used for http and graphql events"
  (:require
   [bp-clients.tv-app.utils.logger :as logger]
   [day8.re-frame.http-fx :refer [http-effect]]
   [re-frame.core :as rf :refer [reg-event-fx reg-fx path reg-event-db]]
   [re-graph.core :as re-graph])
  (:require-macros
   [bp-libs.aero.js :refer [get-config]]))

(goog-define localhost-proxy false)

(def api-path ::api)

(def api-interceptors
  [(path api-path)])

(def api-base-url-path
  "Api base backend url path
  When localhost-proxy is set this will return nil
  All requests should then point to localhost instead"
  (when-not localhost-proxy
    (get-config :backend-api-url)))

(def platform-base-url-path
  "Api base backend url path
  When localhost-proxy is set this will return nil
  All requests should then point to localhost instead"
  (when-not localhost-proxy
    (get-config :platform-url)))

(def tv-login-url
  "TV login url location"
  (str platform-base-url-path (get-config :qr-code-path)))

(def hermes-url-endpoint
  (str api-base-url-path (get-config :hermes-path)))

(defn deep-merge [a & maps]
  (if (map? a)
    (apply merge-with deep-merge a maps)
    (apply merge-with deep-merge maps)))

(defn init-graphql
  "Given a side effect inits graphql with provided config"
  [{:keys [db]} [_ {:keys [url headers instance-id extra-params]}]]
  {:db       (assoc-in db [:re-graph instance-id] true)
   :dispatch [::re-graph/init
              {:ws          nil
               :instance-id instance-id
               :http        {:url                  url
                             :impl                 (cond-> {:headers headers
                                                            ;; see https://github.com/r0man/cljs-http
                                                            ;; and https://github.com/oliyh/re-graph?tab=readme-ov-file#options
                                                            :with-credentials? true}
                                                     extra-params (deep-merge extra-params))
                             :supported-operations #{:query
                                                     :mutate}}}]})

(defn destroy-graphql
  "Given a side effect destroy graphql with :id"
  [db [_ id]]
  (-> db
      (assoc-in [:re-graph id] {})
      (assoc-in [api-path :re-graph id] false)))

(defn query-graphql
  "Given a side effect queries graphql"
  [_ [_ {:keys [instance-id id query variables] :as query-config}]]
  {:dispatch [::re-graph/query {:instance-id instance-id
                                :id          (or id (random-uuid))
                                :query       query
                                :variables   variables
                                :callback    [::handle-graphql-response query-config]}]})

(defn mutate-graphql
  "Given a side effect queries graphql"
  [_ [_ {:keys [instance-id id query variables] :as query-config}]]
  {:dispatch [::re-graph/mutate {:instance-id instance-id
                                 :id          (or id (random-uuid))
                                 :query       query
                                 :variables   variables
                                 :callback    [::handle-graphql-response query-config]}]})

(defn handle-graphql-response
  [_ [_ {:keys [on-success on-error decoder response] :as _query}]]
  (let [{:keys [errors data]} response
        errors?               (and (pos? (count errors)) (not (map? data)))
        ;; @todo trust in query errors and/or return type
        dispatch              (if errors?
                                (conj on-error errors)
                                [on-success {:decoder decoder
                                             :data    data}])]
    {:dispatch dispatch}))

(defn http-fx
  "Wrapper around ::http requests.
  Here we can intercept, modify
  and/or log at will."
  [request]
  (http-effect request))

(defn no-auth-graphql
  "This config is used to know when a request is NOT supposed to contain authorization headers.
  User assumed to be logged out."
  [{:keys [db]} _]
  {:dispatch [::initialize-graqhql {:instance-id :no-auth
                                    :url         hermes-url-endpoint
                                    :headers     {"bp-session-id" (-> db :bp-clients.tv-app.analytics.events/analytics :session-id)
                                                  "bp-app-version" logger/code-version}}]})

(defn auth-graphql
  "This config is used to know when a request IS supposed to contain authorization headers.
  User assumed to be logged in."
  [{:keys [db]} [_ {:keys [auth-token]}]]
  {:dispatch [::initialize-graqhql {:instance-id :auth
                                    :headers     {"Authorization"  auth-token
                                                  "bp-session-id"  (-> db :bp-clients.tv-app.analytics.events/analytics :session-id)
                                                  "bp-app-version" logger/code-version}
                                    :url         hermes-url-endpoint}]})

(reg-fx ::http http-fx)
(reg-event-fx ::initialize-graqhql api-interceptors init-graphql)
(reg-event-db ::destroy-graphql destroy-graphql)
(reg-event-fx ::query-graphql api-interceptors query-graphql)
(reg-event-fx ::mutate-graphql api-interceptors mutate-graphql)
(reg-event-fx ::handle-graphql-response api-interceptors handle-graphql-response)
(reg-event-fx ::init-graphql-with-auth auth-graphql)
(reg-event-fx ::init-graphql-no-auth no-auth-graphql)

(comment
  ;; initializes and instance
  (rf/dispatch [::initialize-graqhql {:instance-id :no-auth
                                      :url         hermes-url-endpoint}])
  ;; destroys an instance
  (rf/dispatch [::destroy-graphql :no-auth])

  ;; sends a mutation query
  #_{:clj-kondo/ignore [:unresolved-namespace]}
  (rf/dispatch [::mutate-graphql (merge {:instance-id :no-auth
                                         :on-success  :some-event-success
                                         :on-error    [:some-event-error]}
                                        (bp-clients.tv-app.api.graphql.purgatorium/init-session-mutation))]))
